import { createSlice } from '@reduxjs/toolkit';

// Live overlay of "I'm working on this file" state, keyed by app (form) id.
// Fed by the ws/app-activity/ socket and by local toggles. Card/detail
// components read this first and fall back to the working_by/working_since
// fields on the app payload they were rendered from.
const workingOnSlice = createSlice({
  name: 'workingOn',
  initialState: {
    byAppId: {},
  },
  reducers: {
    setAppWorkingOn: (state, action) => {
      const { app_id, working_by, working_since } = action.payload;
      if (app_id == null) return;
      state.byAppId[String(app_id)] = {
        working_by: working_by ?? null,
        working_since: working_since ?? null,
      };
    },
  },
});

export const { setAppWorkingOn } = workingOnSlice.actions;
export default workingOnSlice.reducer;
